export default String.raw`
.mainBanner {
    width: 100%;
    position: relative;
    user-select: none;
    padding: 0 9%;

    &__swiper {
        border-radius: 12px;
    }

    &__slide {
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 100%;
        background-color: #f2f2f2;
        border-radius: 12px;

        picture {
            width: 100%;
            height: auto;
            display: flex;
        }

        img {
            border-radius: 12px;
            width: 100%;
            height: auto;
        }

        a {
            display: flex;
        }

        .placeholder {
            width: 567px;
            height: 425px;
            display: flex;
            position: relative;

            &__image {
                object-fit: contain;
                min-height: 170px;
                max-width: 100%;
                width: 100%;
                object-position: 50% 50%;
                background-color: #f2f2f2;
                height: auto;
                max-height: 680px;
            }
        }

        &-container {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            top: 0;
            left: 100px;
            width: 100%;
            height: 100%;

            &-box {
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: fit-content;
                max-width: 45%;
                padding: 32px;
                background-color: $bannerTextFieldColor;
                color: black;
                border-radius: 8px;

                a {
                    width: fit-content;
                }

                h1 {
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    word-break: normal;
                    overflow-wrap: break-word;
                    font-weight: 700;
                    margin-bottom: 16px;
                    color: $bannerFontColor;
                }

                h3 {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    word-break: normal;
                    overflow-wrap: break-word;
                    margin-bottom: 32px;
                    color: $bannerSecondaryFontColor;
                }

                .primary-action-button {
                    width: 277px;
                    height: 36px;
                    padding: 8px 32px;
                } 
            }
        }

        &-placeholder {
            color: #6c6c6c;
            position: absolute;
            text-align: center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0;

            &::after {
                content: 'Desktop';
            }
        }
    }

    &__prev, &__next {
        position: absolute;
        z-index: 90;
        top: calc(50% - 24px);

        svg {
            width: 16px;
            height: 16px;
        }
    }

    &__prev {
        left: calc(-24px + 9%);

        svg {
            rotate: 180deg;
        }
    }

    &__next {
        right: calc(-24px + 9%);
    }

    .swiper-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        position: static;
        height: 12px;

        &-bullet {
            width: 32px;
            height: 4px;
            background-color: $lighterColor;
            opacity: 1;
            border-radius: 2px;
            margin: 0 5px;

            &-active {
                background-color: $secondaryColor;
            }
        }
    }
}

.products-page {
    .mainBanner {
        &__prev {
            left: calc(9% - 24px);
        }

        &__next {
            right: calc(9% - 24px);
        }

        margin-bottom: 30px;
    }
}
`